import { Select } from 'components/Select/Select';
import type { SelectOptionType } from 'components/Select/SelectOption';
import type { FC } from 'react';

interface Props {
  hasError: boolean;
  onValueChange: (value: string) => void;
  value: string;
  options: SelectOptionType<string>[];
}

export const SelectFilterRule: FC<Props> = (props) => {
  const handleValueChange = (value: string | null) => {
    props.onValueChange(value ?? '');
  };

  return (
    <Select
      hasError={props.hasError}
      options={props.options}
      value={props.value || null}
      onChange={handleValueChange}
      size='small'
    />
  );
};
